import mermaid from 'mermaid'
import { defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin((nuxtApp) => {
  mermaid.initialize({
    startOnLoad: true,
    theme: 'dark',
    securityLevel: 'loose',
  })
  nuxtApp.provide('mermaid', mermaid)
})
